module.exports = __webpack_public_path__ + "media/images/select2-72906443538f20eac6331eccc6cfdf43.png";